export default "__VITE_ASSET__CCBnYD2I__"